import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const initialState = {
  authData: {},
  carList: [],
  driversList: [],
  orders: {},
  pageAccess: [],
  userData: {},
  userRoles: [],
  showRetailDashboard: false,
  showGroupFleetAdminLandingPage: false,
  companyGroup:null
};

/// useBoundStore.persist.clearStorage()

export const usePersonStore = create(
  persist(
    (set) => ({
      authData: {},
      setAuthData: (authData) => set(() => ({ authData })),
      userData: {},
      setUserData: (userData) => set(() => ({ userData })),
      userRoles: [],
      setUserRoles: (userRoles) => set(() => ({ userRoles })),
      pageAccess: [],
      setPageAccess: (pageAccess) => set(() => ({ pageAccess })), // pageAccess
      driversList: [],
      setDriverList: (driversList) => set(() => [driversList]), // this format doesnt work
      carList: [],
      setCarList: (carList) => set(() => [carList]), // this format doesnt work
      orders: {},
      setOrders: (orders) => set(() => ({ orders })),
      showRetailDashboard: false,
      setShowRetailDashBoardType: (value) =>
        set(() => ({ showRetailDashboard: value })),
      showGroupFleetAdminLandingPage:false,
      setShowGroupFleetAdminLandingPage: (value) => set(() => ({showGroupFleetAdminLandingPage: value})),
      refreshSideBar: false,
      setRefreshSideBar: (value) => set(() => ({ refreshSideBar: value })),
      fetchCarList: false,
      setFetchCars: (value) => set(() => ({ fetchCarList: value })),
      reset: () => {
        set(initialState);
      },
    }),
    {
      name: 'user-info',
      storage: createJSONStorage(() => localStorage),
    },
    {
      partialize: (state) => ({
        showRetailDashboard: state.showRetailDashboard,
        userRoles: state.userRoles, // store only access token in persists store
        pageAccess: state.pageAccess,
        userData: state.userData,
      }),
    }
  )
);

export default usePersonStore;
